function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.863 9.4l-5.865 6.04c-.11.12-.27.18-.43.18a.56.56 0 01-.42-.18L8.304 12.6a.61.61 0 010-.85c.23-.24.61-.23.85 0l2.413 2.41 5.444-5.6c.23-.24.61-.24.85-.01.221.23.231.61 0 .85z",
  fill: "#5FCE87"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.068.53C5.743.53.598 5.67.598 11.99c0 6.32 5.144 11.46 11.47 11.46 6.325 0 11.47-5.14 11.47-11.46 0-6.32-5.135-11.46-11.47-11.46zm0 21.73c-5.665 0-10.269-4.6-10.269-10.26S6.403 1.74 12.068 1.74 22.337 6.34 22.337 12s-4.604 10.26-10.27 10.26z",
  fill: "#5FCE87"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.992 8.56l-5.445 5.6-2.412-2.41a.61.61 0 00-.85 0 .6.6 0 000 .85l2.842 2.84c.11.11.27.18.42.18.16 0 .31-.07.43-.18l5.866-6.04a.6.6 0 00-.01-.85.59.59 0 00-.841.01z",
  fill: "#5FCE87"
});

function SvgApproved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "248c3d2314af9c68dcb9f17e0b2ff2fb.svg";
export { SvgApproved as ReactComponent };